module.exports = __webpack_public_path__ + "static/img/2.ea565cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/zh/2.png
// module id = fXfQ
// module chunks = 0